import { Skeleton, Stack } from '@inflearn/ds-react-next';
import { range } from 'lodash-es';

interface SectionSkeletonProps {
  lines: number;
}

export const SectionSkeleton = ({ lines }: SectionSkeletonProps) => {
  return (
    <Stack gap={8}>
      {range(lines).map((line) => (
        <Skeleton key={line} w="100%" h={20} radius="md" />
      ))}
    </Stack>
  );
};
